const { v4: uuidv4 } = require('uuid');

export default [
  {
    key: uuidv4(),
    name: null,
    fields: [
      {
        name: 'name',
        label: 'Location Name',
        type: 'text',
        validation: 'required|max:40|min:2',
        dense: true,
        hideDetails: true
      }
    ]
  }
];
